import { REQUEST_SOURCES } from "../types"

export const requestSources = () => ({
	type: REQUEST_SOURCES,
})
